import styled, {createGlobalStyle, keyframes} from 'styled-components';

const qrScan = keyframes`
    0% { opacity: 0; top: 0; }
    12% { opacity: 1; }
    88% { opacity: 1; }
    100% { opacity: 0; top: 100%; }
`;

const qrFire = keyframes`
    0% { opacity: 0; transform: scale(.2) rotate(-18deg); }
    22% { opacity: 1; transform: scale(1.35) rotate(8deg); }
    45% { transform: scale(1) rotate(-4deg); }
    70% { opacity: 1; transform: scale(1.12) rotate(2deg); }
    100% { opacity: 0; transform: scale(2.4) rotate(0); }
`;

export const scanline = styled.div`
    position: absolute;
    left: -2%;
    width: 104%;
    top: 0;
    height: 6px;
    border-radius: 6px;
    background: linear-gradient(90deg, transparent, #f28c00, #ff3b00, #f28c00, transparent);
    box-shadow: 0 0 22px 7px rgba(255, 90, 0, .85);
    opacity: 0;
    pointer-events: none;
    animation: ${qrScan} 1s ease-in-out forwards;
`;

export const fire = styled.div<{$image: string}>`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 130px;
    height: 130px;
    margin: -65px 0 0 -65px;
    background: url(${p => p.$image}) center / contain no-repeat;
    opacity: 0;
    pointer-events: none;
    filter: drop-shadow(0 0 22px rgba(255, 80, 0, .85));
    animation: ${qrFire} 1.5s ease-out .85s forwards;
`;

const qrRing = keyframes`
    0% { width: 60px; height: 60px; margin-left: -30px; margin-top: -30px; opacity: 1; }
    100% { width: 560px; height: 560px; margin-left: -280px; margin-top: -280px; opacity: 0; }
`;

const qrFly = keyframes`
    0% { transform: translate(0, 0) rotate(var(--r0)) scale(1); opacity: 1; }
    70% { opacity: .75; }
    100% { transform: translate(var(--dx), var(--dy)) rotate(var(--r1)) scale(.3); opacity: 0; }
`;

export const burstGlobalStyle = createGlobalStyle`
    .qr-ring {
        position: fixed;
        border: 5px solid #ff7a00;
        border-radius: 50%;
        box-shadow: 0 0 30px 8px rgba(255, 120, 0, .85), inset 0 0 20px rgba(255, 90, 0, .4);
        pointer-events: none;
        z-index: 9999;
        animation: ${qrRing} .9s ease-out forwards;
    }

    .qr-particle {
        position: fixed;
        pointer-events: none;
        z-index: 9999;
        animation: ${qrFly} 2s ease-out forwards;
    }
`;
